






import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import AdminFooter from "@/components/admin/Footer.vue";
import UserFooter from "@/components/user/Footer.vue";
import CustomerFooter from "@/components/customer/Footer.vue";
@Component({
  components: {
    AdminFooter,
    UserFooter,
    CustomerFooter
  }
})
export default class extends Vue {
  @Getter("auth/isAdmin")
  public isAdmin!: boolean;
  @Getter("auth/isUser")
  public isUser!: boolean;
}
